import { Trans, useLingui } from '@lingui/react/macro'

import { Alert } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

export function ErrorAlert() {
  const { t } = useLingui()

  return (
    <Alert icon={<IconAlertCircle size={16} />} title={t`Error`} color="red">
      <Trans>Failed to load data. Please try again.</Trans>
    </Alert>
  )
}
